<template>
    <div class="card-historico-pedidos-expedidos-faturados">      
        <g-card :temCabecalho="false" :expansivel="false">
            <div class="header-detalhes-secundario">
                <div class="header-detalhes-secundario-titulo">
                    <g-button
                    class="buscar-button-header"
                    largura="35px"
                    icone="icone_voltar.svg"
                    negritoTexto
                    tamanhoIcone="10px"
                    cor="#FFFFFF"
                    altura="30px"
                    :sombreado="false"
                    @click="voltar()"
                    />
                    <div class="titulo-detalhes-cabecalho"> Histórico do Pedido</div>
                </div>

                <div class="header-icons" v-tooltip="'Abre uma janela para a impressão dos detalhes do cliente!'">
                    <g-button
                    class="botoes"
                    altura="35px"
                    largura="35px"
                    tamanhoIcone="15px"
                    icone="icone_print.svg"
                    >
                    </g-button>
                </div>
            </div>

            <div class="conteudo-card-historico-pedidos-expedidos-faturados">
                <g-card class="card-resultado" margem="20px" :expansivel="false" :temCabecalho="false">
                    <div class="grupo-dados-parcela topico">
                    <div class="dados-parcela-cliente">
                        <div class="titulo-conteudo-detalhes"> Pedido / Parcela </div>
                        <div class="label-conteudo"> {{this.codigoPedido}}  / {{this.numeroParcela}} </div>
                    </div>
                </div>
            <div class="card-resultado-content" v-if="mensagemvazio">
                <img class="imagem-nenhuma-info" src="@/assets/imgs/Ilustracao_erro.svg"/>
                <div class="card-resultado-text"> Nenhum Histórico de Pedido Encontrado! </div>
                <div class="card-resultado-subtext"> </div>
            </div>

            <div v-else-if="!mensagemvazio">
                <g-data-table
                TextoVazio="Nenhum Histórico Encontrado"
                Titulo="Histórico"
                altura="auto"
                :valores = "HistoricoParcelasArray"
                :colunas="Colunas"
                :Paginacao="true"
                :NumeroLinhas="8"
                :Editavel= "false"
                :Imprimivel= "false"
                :rowEditor="false"
                :FiltroGeral = "false"
                :checkprancheta = "false"
                :FiltrosEspecificos = "false"
                :esconderColunaFrozen = "true"
                :ehExpansivel = "true"
                dataKey="pedidoHistoricoAlteracaoId"
                >
                
                  <template #expansivel="slotProps">
                    
                    <g-data-table
                    TextoVazio="Nenhum Histórico Encontrado"
                        Titulo="Histórico"
                        altura="auto"
                        :valores = "[slotProps.linha.data]"
                        :colunas="ColunasSubGrid"
                        :NumeroLinhas="8"
                        :Editavel= "false"
                        :Imprimivel= "false"
                        :rowEditor="false"
                        :checkprancheta = "false"
                        :esconderColunaFrozen = "true"
                        :esconderHeader = "true"
                        :FiltrosEspecificos = "false"
                        :FiltroGeral = "false"
                        :Paginacao="false"
                        dataKey="pedidoHistoricoAlteracaoId"
                        >
                      </g-data-table>
                  </template>
              </g-data-table>
            </div>
            </g-card>
            </div>
        </g-card>
    </div>
</template>

<script>
import HistoricoPedidosExpedidosFaturados from './HistoricoPedidoExpedidoFaturado.js'
export default HistoricoPedidosExpedidosFaturados
</script>

<style scoped>

.header-titulo-voltar {
  width: 100%;
  display: flex;
  align-items: flex-end;
}

.topico {
  padding-bottom: 20px;
}

.grupo {
  color: #4f2c19;
  text-align: left;
  font-family: "MontSerrat";
  font-weight: bold;
  margin-top: 30px;
  display: flex;
}

.titulo {
  color: #3e3e3e;
  text-align: left;
  font-family: "MontSerrat";
  font-weight: 500;
  margin-top: 15px;
}

.conteudo {
  color: #8a8a8a;
  text-align: left;
  font-family: "MontSerrat";
  margin-bottom: 10px;
}

@media(min-width:310px) {
.header-historico-pedidos-expedidos-faturados {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 10px 0;
    border-bottom: 1px solid #f0f0f0;
}

.topico  {
    display: flex;
    flex-wrap: wrap;
    column-gap: 15%;
}

.grupo {
    font-size: 18px;
}
}

@media(min-width:368px) {
.header-historico-pedidos-expedidos-faturados {
    grid-template-columns: 25% repeat(2, auto);
}
}

@media(min-width:600px) {
.header-historico-pedidos-expedidos-faturados {
    padding: 20px 0 10px;
}
}

@media(min-width:801px) {
.conteudo-card-historico-pedidos-expedidos-faturados {
    padding: 0 30px;
}
}

@media(min-width:1025px) {
.conteudo-card-historico-pedidos-expedidos-faturados {
    padding: 0 50px;
}

.grupo-dados-produto, .grupo-componentes, .grupo-observacao {
    border-bottom: none;
    border-bottom: 1px solid #e6e6e6;
    margin-top: 10px;
    column-gap: 6%;
}

.grupo {
    font-size: 19px;
}
}

@media(min-width:1285px) {}

@media(min-width:1500px) {}
</style>